const fontFamily =
  'Relative Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji';

export const dashboardTheme = {
  token: {
    fontFamily,
  },
  components: {
    Button: {
      borderRadius: 24,
      borderRadiusSM: 20,
      colorBorder: 'rgb(218, 216, 210)',
      colorPrimary: '#142138',
      colorPrimaryActive: 'rgb(34, 59, 168)',
      colorPrimaryHover: 'rgb(34, 59, 168)',
      colorPrimaryBorder: 'rgb(20, 33, 56)',
      paddingInline: 24,
      controlHeight: 48,
      controlHeightSM: 40,
      paddingInlineSM: 16,
      fontWeight: 500,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      colorLink: 'rgb(20, 33, 56)',
      colorLinkActive: 'rgb(34, 59, 168)',
      colorLinkHover: 'rgb(34, 59, 168)',
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorError: 'rgb(204, 27, 0)',
      colorErrorActive: 'rgb(245, 86, 61)',
      colorErrorBorderHover: 'rgb(245, 86, 61)',
      colorErrorHover: 'rgb(245, 86, 61)',
      groupBorderColor: 'rgb(218, 216, 210)',
      colorText: 'rgb(20, 33, 56)',
    },
    Switch: {
      colorPrimary: 'rgb(20, 33, 56)',
      colorPrimaryBorder: 'rgb(20, 33, 56)',
      colorPrimaryHover: 'rgb(34, 59, 168)',
      trackMinWidthSM: 48,
      trackMinWidth: 48,
      trackHeightSM: 24,
      trackHeight: 24,
      handleSizeSM: 20,
      handleSize: 20,
      colorTextQuaternary: 'rgb(218, 216, 210)',
      colorTextTertiary: 'rgb(34, 59, 168)',
    },
    Tag: {
      borderRadiusSM: 4,
      borderRadius: 4,
      colorPrimary: 'rgb(20, 33, 56)',
      fontSize: 10,
      fontSizeIcon: 10,
      colorPrimaryActive: 'rgb(20, 33, 56)',
      colorPrimaryHover: 'rgb(20, 33, 56)',
      colorBorder: 'rgb(218, 216, 210)',
    },
    Tooltip: {
      borderRadius: 4,
      boxShadowSecondary: 'none',
      sizePopupArrow: 16,
      colorBgSpotlight: 'rgb(20, 33, 56)',
    },
    Select: {
      borderRadius: 8,
      borderRadiusLG: 8,
      borderRadiusXS: 8,
      controlHeight: 48,
      controlHeightLG: 48,
      controlHeightSM: 48,
      colorBorder: 'rgb(218, 216, 210)',
      boxShadowSecondary: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      borderRadiusSM: 4,
      optionSelectedBg: 'rgb(245, 244, 241)',
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      optionActiveBg: 'rgb(245, 244, 241)',
      colorText: 'rgb(20, 33, 56)',
      colorTextPlaceholder: 'rgba(110, 110, 110, 0.65)',
      colorTextQuaternary: 'rgb(20, 33, 56)',
      multipleItemBg: 'rgb(245, 244, 241)',
      multipleSelectorBgDisabled: 'rgb(218, 216, 210)',
      multipleItemColorDisabled: 'rgb(110, 110, 110)',
      multipleItemBorderColorDisabled: 'rgb(245, 244, 241)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      multipleItemHeightLG: 24,
      multipleItemHeightSM: 24,
      multipleItemHeight: 24,
      paddingSM: 12,
      paddingXXS: 12,
      paddingXS: 12,
    },
    TreeSelect: {
      borderRadius: 4,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      titleHeight: 48,
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      optionActiveBg: 'rgb(245, 244, 241)',
      colorBgTextHover: 'rgb(245, 244, 241)',
      colorText: 'rgb(20, 33, 56)',
      boxShadowSecondary: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      controlItemBgActiveHover: 'rgb(245, 244, 241)',
      controlItemBgActive: 'rgb(245, 244, 241)',
      controlItemBgHover: 'rgb(245, 244, 241)',
      colorTextPlaceholder: 'rgba(110, 110, 110, 0.65)',
      colorTextQuaternary: 'rgb(20, 33, 56)',
    },
    Dropdown: {
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorText: 'rgb(20, 33, 56)',
      borderRadiusLG: 8,
      borderRadiusSM: 4,
      borderRadiusXS: 4,
      controlHeight: 48,
      controlHeightLG: 48,
      controlHeightSM: 48,
      boxShadowSecondary: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      boxShadowPopoverArrow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      optionActiveBg: 'rgb(245, 244, 241)',
      controlItemBgActiveHover: 'rgb(245, 244, 241)',
      controlItemBgActive: 'rgb(245, 244, 241)',
      controlItemBgHover: 'rgb(245, 244, 241)',
      colorTextQuaternary: 'rgb(20, 33, 56)',
      paddingXXS: 8,
      paddingXS: 8,
      controlPaddingHorizontal: 0,
      colorTextDescription: 'rgb(20, 33, 56)',
      colorPrimaryBorder: 'rgb(20, 33, 56)',
    },
    Card: {
      borderRadiusLG: 16,
      boxShadowCard: 'none',
      boxShadowTertiary: 'none',
      padding: 24,
      paddingLG: 24,
      colorBorderSecondary: 'rgb(218, 216, 210)',
    },
    Collapse: {
      borderRadiusLG: 8,
      colorTextHeading: 'rgb(20, 33, 56)',
      colorText: 'rgb(20, 33, 56)',
      colorBorder: 'rgb(218, 216, 210)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      headerBg: 'rgb(255, 255, 255)',
      headerPadding: '16px 16px',
      contentPadding: '24px 16px',
      contentBg: 'rgb(255, 255, 255)',
    },
    Avatar: {
      boxShadowSecondary: 'none',
    },
    Popover: {
      boxShadowSecondary: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      boxShadowPopoverArrow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      borderRadiusLG: 8,
      borderRadiusXS: 2,
      colorText: 'rgb(20, 33, 56)',
      colorTextHeading: 'rgb(20, 33, 56)',
    },
    Message: {
      colorInfo: 'rgb(110, 110, 110)',
      colorSuccess: 'rgb(14, 122, 74)',
      colorError: 'rgb(204, 27, 0)',
      colorText: 'rgb(20, 33, 56)',
      boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      colorWarning: 'rgb(204, 27, 0)',
    },
    Divider: {
      colorSplit: 'rgb(218, 216, 210)',
      marginLG: 16,
    },
    Typography: {
      colorText: 'rgb(20, 33, 56)',
      colorSuccess: 'rgb(14, 122, 74)',
      colorError: 'rgb(204, 27, 0)',
      colorErrorActive: 'rgb(245, 86, 61)',
      colorErrorHover: 'rgb(245, 86, 61)',
      colorLink: 'rgb(20, 33, 56)',
      colorLinkActive: 'rgb(34, 59, 168)',
      colorLinkHover: 'rgb(34, 59, 168)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorTextHeading: 'rgb(20, 33, 56)',
      colorTextDescription: 'rgb(110, 110, 110)',
      colorWarning: 'rgb(204, 27, 0)',
    },
    Modal: {
      borderRadiusLG: 16,
      boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.24)',
      titleColor: 'rgb(20, 33, 56)',
      colorSplit: 'rgb(218, 216, 210)',
      colorText: 'rgb(20, 33, 56)',
      colorBgTextHover: 'rgb(245, 244, 241)',
      fontSizeHeading5: 20,
    },
    Input: {
      controlHeight: 48,
      colorBorder: 'rgb(218, 216, 210)',
      activeBorderColor: 'rgb(20, 33, 56)',
      hoverBorderColor: 'rgb(20, 33, 56)',
      colorPrimary: 'rgb(20, 33, 56)',
      colorPrimaryHover: 'rgba(64, 150, 255, 0)',
      colorPrimaryActive: 'rgba(9, 88, 217, 0)',
      activeShadow: 'none',
      errorActiveShadow: 'none',
      warningActiveShadow: 'none',
      colorErrorBorderHover: 'rgb(245, 86, 61)',
      colorErrorText: 'rgb(204, 27, 0)',
      colorError: 'rgb(204, 27, 0)',
      colorText: 'rgb(20, 33, 56)',
      colorSplit: 'rgb(218, 216, 210)',
      colorIcon: 'rgb(20, 33, 56)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorTextPlaceholder: 'rgb(110, 110, 110)',
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      colorWarning: 'rgb(204, 27, 0)',
      colorWarningText: 'rgb(204, 27, 0)',
      colorWarningBorderHover: 'rgb(245, 86, 61)',
      colorTextDescription: 'rgb(20, 33, 56)',
      borderRadius: 8,
      colorTextQuaternary: 'rgb(20, 33, 56)',
    },
    Form: {
      labelColor: 'rgb(20, 33, 56)',
      labelRequiredMarkColor: 'rgb(204, 27, 0)',
      colorBorder: 'rgb(218, 216, 210)',
      colorError: 'rgb(204, 27, 0)',
      colorPrimary: 'rgb(20, 33, 56)',
      colorSuccess: 'rgb(14, 122, 74)',
      colorText: 'rgb(20, 33, 56)',
      colorTextDescription: 'rgb(20, 33, 56)',
      colorWarning: 'rgb(204, 27, 0)',
    },
    InputNumber: {
      colorTextDescription: 'rgb(20, 33, 56)',
      colorBorder: 'rgb(218, 216, 210)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      colorText: 'rgb(20, 33, 56)',
      controlHeight: 48,
      borderRadius: 8,
      activeShadow: 'none',
      errorActiveShadow: 'none',
      warningActiveShadow: 'none',
      controlHeightSM: 32,
    },
    DatePicker: {
      colorSplit: 'rgb(218, 216, 210)',
      controlHeight: 48,
      borderRadiusLG: 16,
      borderRadius: 8,
      borderRadiusSM: 8,
      colorText: 'rgb(20, 33, 56)',
      colorIcon: 'rgb(20, 33, 56)',
      activeShadow: 'none',
      errorActiveShadow: 'none',
      warningActiveShadow: 'none',
      controlItemBgActiveHover: 'rgb(245, 244, 241)',
      controlItemBgActive: 'rgb(245, 244, 241)',
      controlItemBgHover: 'rgb(245, 244, 241)',
      colorTextPlaceholder: 'rgb(110, 110, 110)',
      colorPrimaryBorder: 'rgb(20, 33, 56)',
      colorBorder: 'rgb(218, 216, 210)',
      colorPrimary: 'rgb(34, 59, 168)',
      colorTextDisabled: 'rgb(178, 175, 164)',
      cellHoverBg: 'rgb(245, 244, 241)',
      boxShadowPopoverArrow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16);',
      boxShadowSecondary: '0px 0px 8px 0px rgba(0, 0, 0, 0.16);',
      cellActiveWithRangeBg: 'rgb(218, 223, 247)',
      cellRangeBorderColor: 'rgb(218, 223, 247)',
      cellHoverWithRangeBg: 'rgb(218, 223, 247)',
    },
    Alert: {
      colorSuccessBg: 'rgb(245, 244, 241)',
      colorInfoBg: 'rgb(245, 244, 241)',
      colorErrorBg: 'rgb(245, 244, 241)',
      colorWarningBg: 'rgb(245, 244, 241)',
      colorErrorBorder: 'none',
      colorError: 'rgb(20, 33, 56)',
      colorWarningBorder: 'none',
      colorWarning: 'rgb(20, 33, 56)',
      colorSuccessBorder: 'none',
      colorSuccess: 'rgb(20, 33, 56)',
      colorInfoBorder: 'none',
      colorInfo: 'rgb(20, 33, 56)',
      colorIcon: 'rgb(20, 33, 56)',
      colorText: 'rgb(20, 33, 56)',
      colorTextHeading: 'rgb(20, 33, 56)',
      borderRadiusLG: 8,
    },
    Tabs: {
      colorBorder: 'rgb(218, 216, 210)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorBorderSecondary: 'rgba(245, 244, 241, 0)',
      colorText: 'rgb(20, 33, 56)',
      colorTextHeading: 'rgb(20, 33, 56)',
      colorTextDescription: 'rgb(20, 33, 56)',
      itemHoverColor: 'rgb(20, 33, 56)',
      itemSelectedColor: 'rgb(20, 33, 56)',
      itemActiveColor: 'rgb(20, 33, 56)',
      itemColor: 'rgb(110, 110, 110)',
      boxShadowSecondary: 'none',
      horizontalItemGutter: 24,
      fontSize: 16,
    },
    Radio: {
      colorBorder: 'rgb(218, 216, 210)',
      colorText: 'rgb(20, 33, 56)',
      dotSize: 14,
      colorPrimaryHover: 'rgb(34, 59, 168)',
      colorPrimaryActive: 'rgb(34, 59, 168)',
      colorPrimaryBorder: 'rgb(20, 33, 56)',
      buttonCheckedBgDisabled: 'rgb(218, 216, 210)',
      dotColorDisabled: 'rgb(218, 216, 210)',
      colorBgContainerDisabled: 'rgb(245, 244, 241)',
      buttonSolidCheckedBg: 'rgb(20, 33, 56)',
      buttonBg: 'rgb(255, 255, 255)',
      buttonCheckedBg: 'rgb(255, 255, 255)',
      colorPrimary: 'rgb(20, 33, 56)',
      buttonColor: 'rgb(20, 33, 56)',
      buttonSolidCheckedColor: 'rgb(255, 255, 255)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      buttonSolidCheckedHoverBg: 'rgb(34, 59, 168)',
      buttonSolidCheckedActiveBg: 'rgb(34, 59, 168)',
      buttonCheckedColorDisabled: 'rgb(218, 216, 210)',
      radioSize: 24,
    },
    Checkbox: {
      colorBorder: 'rgb(218, 216, 210)',
      colorBgContainerDisabled: 'rgb(218, 216, 210)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      borderRadiusSM: 16,
    },
    Notification: {
      colorWarning: 'rgb(204, 27, 0)',
      colorTextHeading: 'rgb(20, 33, 56)',
      colorText: 'rgb(20, 33, 56)',
      colorSuccess: 'rgba(14, 122, 74, 0.98)',
      colorPrimaryBorder: 'rgba(79, 86, 94, 0.99)',
      colorInfo: 'rgb(20, 33, 56)',
      boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.16)',
      borderRadiusLG: 8,
      colorError: 'rgb(204, 27, 0)',
    },
    Table: {
      boxShadowSecondary: 'none',
      colorText: 'rgb(20, 33, 56)',
      colorTextDescription: 'rgb(20, 33, 56)',
      colorTextHeading: 'rgb(20, 33, 56)',
      headerBg: 'rgb(255, 255, 255)',
      headerColor: 'rgb(110, 110, 110)',
      footerColor: 'rgb(20, 33, 56)',
      controlItemBgHover: 'rgb(245, 244, 241)',
      controlItemBgActive: 'rgb(245, 244, 241)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      headerSortActiveBg: 'rgb(255, 255, 255)',
      headerFilterHoverBg: 'rgb(255, 255, 255)',
      headerSortHoverBg: 'rgb(245, 244, 241)',
      borderColor: 'rgb(218, 216, 210)',
      rowHoverBg: 'rgb(245, 244, 241)',
      rowSelectedHoverBg: 'rgb(245, 244, 241)',
      rowSelectedBg: 'rgb(245, 244, 241)',
      headerSplitColor: 'none',
      rowExpandedBg: 'rgb(255, 255, 255)',
      bodySortBg: 'rgb(255, 255, 255)',
      colorSplit: 'rgb(218, 216, 210)',
      colorLinkActive: 'rgb(245, 244, 241)',
      borderRadius: 16,
      headerBorderRadius: 16,
      footerBorderRadius: 16,
    },
    Pagination: {
      borderRadius: 4,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      colorBorder: 'rgb(218, 216, 210)',
      colorPrimaryBorder: 'rgb(20, 33, 56)',
      colorPrimaryHover: 'rgba(20, 33, 56, 0.77)',
      itemActiveColorDisabled: 'rgb(110, 110, 110)',
      itemActiveBgDisabled: 'rgb(218, 216, 210)',
      colorBgTextActive: 'rgb(245, 244, 241)',
      colorText: 'rgb(110, 110, 110)',
      colorTextDisabled: 'rgb(110, 110, 110)',
      colorTextPlaceholder: 'rgb(110, 110, 110)',
      controlHeight: 30,
      colorBgTextHover: '#CAC8C3',
    },
  },
  Upload: {
    actionsColor: 'rgb(20, 33, 56)',
    colorBorder: 'rgb(218, 216, 210)',
    colorText: 'rgb(20, 33, 56)',
    colorTextHeading: 'rgb(20, 33, 56)',
    controlItemBgHover: 'rgb(245, 244, 241)',
    borderRadiusLG: 8,
    borderRadius: 8,
    colorPrimaryBorder: 'rgb(20, 33, 56)',
    colorPrimaryHover: 'rgb(20, 33, 56)',
    colorTextDescription: 'rgb(20, 33, 56)',
    colorTextDisabled: 'rgb(110, 110, 110)',
  },
  Steps: {
    colorSplit: 'rgb(218, 216, 210)',
    colorText: 'rgb(20, 33, 56)',
  },
};
